import { render, staticRenderFns } from "./entrustModel.vue?vue&type=template&id=6618959a&scoped=true&"
import script from "./entrustModel.vue?vue&type=script&lang=js&"
export * from "./entrustModel.vue?vue&type=script&lang=js&"
import style0 from "./entrustModel.vue?vue&type=style&index=0&id=6618959a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6618959a",
  null
  
)

export default component.exports